import { useQuery } from '@tanstack/react-query';

import Api from '@app/services/api';

export const useGetDocumentQuery = (document_uid: string | null | undefined) => {
  return useQuery({
    queryKey: ['getDocument', document_uid],
    queryFn: () => Api.wms.getDocument(document_uid as string),
    enabled: !!document_uid,
  });
};
